import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { SEOHead } from "@/components/SEOHead";
import { toast } from "sonner";

export default function Login() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      navigate(u.is_admin ? "/admin" : "/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign in failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <SEOHead title="Sign In | Cocoamaya Patisserie" noindex />
      <p className="eyebrow mb-3">Welcome back</p>
      <h1 className="font-display text-4xl mb-10">Sign in</h1>
      <form onSubmit={submit} className="space-y-4">
        <input className="input-field" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        <input className="input-field" type="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        <button className="btn-primary w-full justify-center" disabled={submitting} data-testid="login-submit">
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-8 text-sm" style={{ color: "var(--ink-soft)" }}>
        New here? <Link to="/register" className="underline" data-testid="goto-register">Create an account</Link>
      </p>
    </div>
  );
}
